const starPositions = [
  [6, 17], [21, 9], [39, 22], [54, 13], [72, 7], [87, 19], [97, 32],
  [13, 35], [31, 30], [47, 39], [65, 28], [79, 42], [92, 51],
  [4, 56], [23, 49], [37, 61], [59, 53], [70, 65], [85, 72],
  [11, 76], [29, 84], [48, 75], [61, 89], [77, 94], [95, 87],
  [3, 97], [36, 104], [55, 111], [82, 115], [18, 117],
];

const brightPositions = [
  [9, 24], [34, 15], [61, 19], [81, 31], [96, 45], [18, 57],
  [44, 48], [66, 70], [32, 79], [89, 92], [7, 107], [53, 118],
];

export function HomeSky() {
  return (
    <div className="home-sky">
      {[starPositions, brightPositions].map((positions, depth) => (
        <div key={depth} className={`sky-stars sky-stars-${depth}`}>
          {positions.map(([left, top], i) => (
            <svg key={i} viewBox="0 0 16 16" focusable="false"
              style={{ left: `${left}%`, top: `${top}%`, width: depth ? 10 + i % 3 * 2 : 3 + i % 4 * 1.5 }}>
              {depth || i % 3 === 0
                ? <path d="M8 0C8.8 5.9 10.1 7.2 16 8C10.1 8.8 8.8 10.1 8 16C7.2 10.1 5.9 8.8 0 8C5.9 7.2 7.2 5.9 8 0Z" />
                : <circle cx="8" cy="8" r="3.5" />}
            </svg>
          ))}
        </div>
      ))}

      <svg className="sky-planet sky-saturn" viewBox="0 0 200 140" fill="none" focusable="false">
        <g transform="rotate(-24 100 70)" stroke="currentColor" strokeWidth="1.2">
          <ellipse cx="100" cy="70" rx="92" ry="25" />
          <circle cx="100" cy="70" r="43" fill="#f3d4a2" />
          <path d="M68 42C88 32 113 34 132 46M60 58C79 46 115 46 141 62M63 86C82 98 113 101 132 92" opacity=".5" />
          <path d="M8 70C8 103 192 103 192 70M15 77C43 94 157 94 185 77" />
          <path d="M18 92L23 97M166 29L171 24M178 36L187 33" strokeLinecap="round" opacity=".55" />
        </g>
      </svg>

      <svg className="sky-planet sky-moon" viewBox="0 0 100 100" fill="none" focusable="false">
        <g stroke="currentColor" strokeWidth="1.1">
          <circle cx="50" cy="50" r="39" fill="#dfebef" />
          <path d="M59 12C30 31 30 72 61 87C27 92 9 69 11 46C13 24 35 8 59 12Z" fill="currentColor" fillOpacity=".09" stroke="none" />
          <circle cx="61" cy="33" r="7" /><circle cx="68" cy="59" r="10" />
          <circle cx="42" cy="65" r="4" /><path d="M59 62C59 56 63 52 68 52M56 34C56 30 58 28 61 28" opacity=".45" />
          <path d="M23 31L25 28M24 67L27 71M35 20L38 19" strokeLinecap="round" opacity=".5" />
        </g>
      </svg>

      <svg className="sky-planet sky-orb" viewBox="0 0 100 100" fill="none" focusable="false">
        <g transform="rotate(25 50 50)" stroke="currentColor" strokeWidth="1.1">
          <circle cx="50" cy="50" r="34" fill="#cadfe7" />
          <path d="M25 27C38 34 59 21 72 24M19 36C35 48 61 30 81 38M16 49C35 59 60 39 84 51M20 65C41 76 61 56 80 66M30 78C48 84 60 69 73 75" />
          <ellipse cx="59" cy="58" rx="7" ry="3" opacity=".65" />
        </g>
        <circle cx="89" cy="15" r="3" fill="currentColor" fillOpacity=".25" stroke="currentColor" />
      </svg>
    </div>
  );
}
